"use client";

import clsx from "clsx";
import { UserAllocation } from "@/stores/strategiesStore";

interface UserAllocationBadgeProps {
  allocation: UserAllocation;
}

export const UserAllocationBadge = ({ allocation }: UserAllocationBadgeProps) => {
  const isProfitable = allocation.unrealizedPnl >= 0;

  return (
    <div className="mt-4 rounded-lg bg-slate-800/50 p-3">
      <div className="flex items-center justify-between text-xs">
        <span className="text-slate-500">Your Position</span>
        <span className="font-medium text-white">
          ${allocation.allocatedAmount.toLocaleString()}
        </span>
      </div>
      <div className="mt-1 flex items-center justify-between text-xs">
        <span className="text-slate-500">P&L</span>
        <span
          className={clsx(
            "font-semibold",
            isProfitable ? "text-emerald-400" : "text-rose-400"
          )}
        >
          {isProfitable ? "+" : ""}${allocation.unrealizedPnl.toFixed(2)}
          <span className="ml-1 text-slate-500">
            ({isProfitable ? "+" : ""}
            {allocation.unrealizedPnlPercent.toFixed(1)}%)
          </span>
        </span>
      </div>
    </div>
  );
};
